export const FILTERS = [
  "All",
  "Medical Policy",
  "Healthcare",
  "Travel",
  "Privacy",
  "Media",
  "Creator",
];

export const projects = [
  {
    id: "medpolicyref",
    name: "MedPolicyRef",
    category: "Medical Policy Reference Review SaaS",
    filter: "Medical Policy",
    status: "Live",
    icon: "FileSearch",
    accent: "from-sky-500/25 to-cyan-500/10",
    website: "https://medpolicyref.com",
    playStore: null,
    description:
      "MedPolicyRef helps medical policy analysts and healthcare organizations review the references used in public-facing medical policies. It is designed to identify outdated citations, organize annual reference audits, and support recommendations about which sources should remain, be removed, be replaced, or be added.",
    capabilities: [
      "Medical policy reference extraction",
      "Annual citation review support",
      "Identification of outdated sources",
      "Reference audit recommendations",
      "Policy analyst workflow support",
    ],
    disclaimer:
      "MedPolicyRef supports reference review workflows. It does not make medical decisions or replace professional policy review.",
  },
  {
    id: "routecast",
    name: "RouteCast",
    category: "Weather-Aware Travel & Route Planning",
    filter: "Travel",
    status: "Live",
    icon: "CloudSun",
    accent: "from-teal-500/25 to-sky-500/10",
    website: "https://www.routecastweather.com",
    playStore: null,
    description:
      "RouteCast is a weather-aware route-planning platform built for RV travelers, boondockers, truck drivers, and road trippers. It combines route planning with weather intelligence and travel-focused tools.",
    capabilities: [
      "Route-based weather forecasts",
      "Travel alerts",
      "Road-condition information",
      "Tools for RVers, boondockers, and truck drivers",
      "Mobile-first trip planning",
    ],
    disclaimer: null,
  },
  {
    id: "emergent-vpn",
    name: "Emergent VPN",
    category: "Privacy & Secure Networking",
    filter: "Privacy",
    status: "Live",
    icon: "ShieldCheck",
    accent: "from-blue-500/25 to-indigo-500/10",
    website: "https://emergentvpn.com",
    playStore: "https://play.google.com/store/apps/details?id=com.emergentvpn",
    description:
      "Emergent VPN provides straightforward privacy protection for everyday browsing, travel, mobile data, and public Wi-Fi. The mobile platform uses secure VPN technology and subscription-based access.",
    capabilities: [
      "Encrypted VPN connections",
      "Mobile privacy protection",
      "Secure public Wi-Fi use",
      "Subscription-based access",
      "Android mobile application",
    ],
    disclaimer:
      "Emergent VPN improves everyday privacy. It does not claim total anonymity, guaranteed security, or protection against every threat.",
  },
  {
    id: "endoscopy-nurse-pro",
    name: "Endoscopy Nurse Pro",
    category: "Healthcare Education & Nursing Training",
    filter: "Healthcare",
    status: "Live",
    icon: "GraduationCap",
    accent: "from-cyan-500/25 to-teal-500/10",
    website: "https://endoscopynursepro.com",
    playStore: null,
    description:
      "Endoscopy Nurse Pro is a mobile-first educational platform created to support the orientation and professional development of GI and endoscopy nurses through structured learning modules, procedure education, quizzes, and competency-focused content.",
    capabilities: [
      "Endoscopy nursing education",
      "Structured learning modules",
      "Procedure-room preparation",
      "Colonoscopy workflow education",
      "Quizzes and competency reinforcement",
      "Mobile-first training",
    ],
    disclaimer:
      "Endoscopy Nurse Pro is an educational resource. It is not medical advice or a medical device.",
  },
  {
    id: "patriot-news-us",
    name: "Patriot News US",
    category: "Digital Publishing & News",
    filter: "Media",
    status: "Live",
    icon: "Newspaper",
    accent: "from-sky-500/25 to-blue-500/10",
    website: "https://patriotnewsus.com",
    playStore: null,
    description:
      "Patriot News US is a digital publishing platform created to organize and deliver news-focused content through a modern subscription-based experience.",
    capabilities: [
      "Digital news publishing",
      "Subscription content",
      "Mobile-friendly reading",
      "Audience engagement tools",
    ],
    disclaimer: null,
  },
  {
    id: "tikhooks2",
    name: "TikHooks2",
    category: "Creator & Social Media Technology",
    filter: "Creator",
    status: "Live",
    icon: "Sparkles",
    accent: "from-teal-500/25 to-cyan-500/10",
    website: "https://tikhooks2.com",
    playStore: null,
    description:
      "TikHooks2 is a creator-focused software product designed to help users identify emerging TikTok trends, content angles, and attention-grabbing hooks.",
    capabilities: [
      "Trend discovery",
      "Creator-hook inspiration",
      "Social media content research",
      "Content-idea organization",
    ],
    disclaimer:
      "TikHooks2 is an independent creator tool and has no official relationship with TikTok.",
  },
  {
    id: "simple-background-remover",
    name: "Simple Background Remover",
    category: "Product Photo & Reseller Utility",
    filter: "Creator",
    status: "In Testing",
    icon: "Sparkles",
    iconImage: "/simple-background-remover-icon.png",
    iconAlt: "Simple Background Remover app icon",
    accent: "from-slate-400/20 to-sky-500/10",
    website: "https://simplebackgroundremover.com",
    playStore: null,
    description:
      "Simple Background Remover is a private, on-device mobile utility designed for online resellers and product photographers. Users can remove backgrounds from one image or an entire batch, replace them with pure white or black, and save the completed images directly to their device.",
    capabilities: [
      "Process one photo or up to 50 photos in a batch",
      "Replace backgrounds with pure white or black",
      "On-device image processing",
      "No customer accounts",
      "No cloud photo storage",
      "No advertising",
      "No subscriptions",
      "Android version currently in testing",
      "iPhone version planned",
    ],
    disclaimer: null,
  },
];

export const inDevelopment = {
  id: "in-development",
  name: "Additional Products in Development",
  category: "In Development",
  status: "In Development",
  icon: "Rocket",
  accent: "from-slate-500/20 to-slate-400/5",
  description:
    "Hildreth Technologies LLC continues to develop focused mobile applications, SaaS platforms, healthcare tools, and digital products.",
};

export const areas = [
  { title: "Healthcare & Nursing Education", icon: "Stethoscope" },
  { title: "Medical Policy & Research Technology", icon: "FileSearch" },
  { title: "Mobile Applications", icon: "Smartphone" },
  { title: "Subscription-Based Digital Products", icon: "CreditCard" },
  { title: "Privacy & Secure Networking", icon: "ShieldCheck" },
  { title: "Travel & Weather Intelligence", icon: "CloudSun" },
  { title: "Digital Publishing", icon: "Newspaper" },
  { title: "Social Media & Creator Tools", icon: "Sparkles" },
];
